/*!
  * Furillo ajax-loader.js v2.0.0
  * Copyright 2023 Furillo Agency AB (https://www.furillo.se/)  
  */
export default class AjaxLoader {

    static awaitingLoader = null;

    static addLoader(container) {
        const base = this;

        // Check if loader is already present
        let loader = container.querySelector('.ajax-partials-loader');
        if (loader)
            return;                    

        // Create the loader element
        let loaderElementType = 'span';
        if (container.tagName === 'UL')
            loaderElementType = 'li';        

        loader = document.createElement(loaderElementType);
        loader.classList.add('ajax-partials-loader');

        // Check if a text should be added to the loader element
        const loaderText = container.getAttribute('data-ajax-loader-text')
        if (loaderText && loaderText.length > 0)
            loader.innerText = loaderText;        

        // Wait half a second to avoid unneccessary "flickering"
        clearTimeout(base.awaitingLoader);
        base.awaitingLoader = window.setTimeout(function () {
            container.classList.add('ajax-partials-loading');
            container.appendChild(loader);
        }, 500);
    }

    static removeLoader(container) {
        const base = this;
        clearTimeout(base.awaitingLoader);

        const loader = container.querySelector('.ajax-partials-loader');
        if (loader)
            loader.remove();

        container.classList.remove('ajax-partials-loading');
    }
}